import * as Yup from 'yup';
import { DateTime } from 'luxon';

import EditCustomer from '../Customers/EditCustomer';

import AppointmentList from './Components/AppointmentList';

import AllInclusiveRoundedIcon from '@mui/icons-material/AllInclusiveRounded';
import AutoFixHighRoundedIcon from '@mui/icons-material/AutoFixHighRounded';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import ScheduleIcon from '@mui/icons-material/Schedule';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';

import { displayLabelCustomer } from '../../utils/displayLabels';

const headers = [
  {
    label: 'Ticket ID',
    id: 'service_ticket_id'
  },
  {
    label: 'Customer',
    id: 'client_name'
  },
  {
    label: "Service",
    id: "service_name"
  },
  {
    label: 'Wig ID',
    id: 'wig_id'
  },
  {
    label: 'Status',
    id: 'status',
    multi: true,
    values: [{value: "scheduled", label: "Scheduled", status: "primary"}, {value: "checked_in", label: "Checked In", status: "secondary"}, {value: "prepping", label: "In Prep", status: "warning"}, {value: "in_progress", label: "In Progress", status: "warning"}, {value: "completed", status: "success"}]
  },
  {
    label: 'Station',
    id: 'current_station'
  },
  {
    label: 'Checked In',
    id: 'checked_in_at',
    date: true
  },
  {
    label: 'Appt Date',
    id: 'scheduled_date',
    date: true
  }
];

const filters = [
  {
    id: "scheduled_date",
    type: "date",
    label: "Scheduled Date",
  }
];

const tabs = [
  {id: "all", label: "All", Icon: AllInclusiveRoundedIcon },
  {id: "checked_in", label: "Checked In", Icon: AssignmentTurnedInIcon },
  {id: "prepping", label: "In Prep", Icon: AutoFixHighRoundedIcon },
  {id: "in_progress", label: "In Progress", Icon: HourglassEmptyIcon },
  {id: "completed", label: "Completed", Icon: TaskAltIcon },
  {id: "scheduled", label: "Scheduled", Icon: ScheduleIcon },
]

const fields = [
  { 
    fieldType: "debounceSearchSolo",
    formFieldType: "select",
    select: [],
    name: "customer_id",
    label: "Select Customer",
    url: "customers",
    fieldName: "customer_id",
    displayField: "full_name",
    formUpdates: [{name: "customer_name", field: "full_name"}, {name: "customer_phone", field: "mobile_phone"}],
    setDisplayField: "customer_name",
    FormComponent: <EditCustomer dialog={true}/>,
    displayLabel: displayLabelCustomer,
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "formField",
    formFieldType: "date",
    name: "checked_in_at",
    label: "Check In Date",
    type: "date",
    size: {xs: 12, lg: 3},
  },
  {
    fieldType: "divider",
    header: "Scheduled Appointments",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "Component",
    Component: <AppointmentList />,
    name: "appointments",
    size: {xs: 12, lg: 12}, 
  },
  {
    fieldType: "divider",
    header: "Notes",
    name: "notes",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "notes",
    label: "Notes",
    type: "text",
    multiline: true,
    rows: 4,
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "divider",
    header: "Summary",
    name: "summary",
    size: {xs: 12, lg: 12},
  }
]

const initialValues = {
  customer_id: '',
  stylist_id: '',
  checked_in_at: DateTime.local(),
  checked_in_wigs: [],
  notes: '',
}


const additionalState = {
  customer_name: '',
  customer_phone: '',
  stylist_name: '',
}

const schema = Yup.object().shape({
 
});

// const parseData = (data) => {
//   const parsed = {...data, recurrence_pattern: {...data.recurrence_pattern}};
//   parsed.appointment_date = DateTime.fromISO(data.appointment_date);
//   parsed.start_time = DateTime.fromISO(data.start_time);
//   parsed.end_time = DateTime.fromISO(data.end_time);
//   if (parsed.stylist_id) parsed.stylist_id = data.stylist_id.toString();
//   if (parsed.customer_id) parsed.customer_id = data.customer_id.toString();

//   if (parsed.recurrence_pattern && !isEmpty(parsed.recurrence_pattern)) {
//     parsed.recurrence_pattern.start_date = DateTime.fromISO(parsed.recurrence_pattern.start_date);
//     parsed.recurrence_pattern.end_date = DateTime.fromISO(parsed.recurrence_pattern.end_date);
//   }
//   return parsed
// }

export { fields, initialValues, schema, additionalState, headers, filters, tabs 
  // parseData,
 };